import { render, staticRenderFns } from "./MenuLinkAddEditSidebar.vue?vue&type=template&id=528ec560&scoped=true&"
import script from "./MenuLinkAddEditSidebar.vue?vue&type=script&lang=js&"
export * from "./MenuLinkAddEditSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MenuLinkAddEditSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MenuLinkAddEditSidebar.vue?vue&type=style&index=1&id=528ec560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ec560",
  null
  
)

export default component.exports